module.exports = __webpack_public_path__ + "img/hero-2-img.b48feb33.png";